const types = {
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  APPEND_ACCOUNT: 'APPEND_ACCOUNT',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  SET_PROFILE: 'SET_PROFILE',
  CLEAR_PROFILE: 'CLEAR_PROFILE',
  CLEAR_USER_REVS: 'CLEAR_USER_REVS',
  SET_USER_REVS: 'SET_USER_REVS',
  REMOVE_USER_FROM_LIST: 'REMOVE_USER_FROM_LIST',
  SET_REV_CREATE_ACCOUNTS: 'SET_REV_CREATE_ACCOUNTS',
  CLEAR_REV_CREATE_ACCOUNTS: 'CLEAR_REV_CREATE_ACCOUNTS',
}

export default types
